(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a2-assembly-video"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(root) {
    root.querySelectorAll('.a2-assembly-video').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const button = video.parentElement.querySelector('.a2-assembly-toggle');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const lifecycle = new AbortController();
      const options = {signal: lifecycle.signal};
      let visible = false;
      let wanted = !reduced.matches;
      let pending = false;
      video.muted = true;
      video.controls = false;
      button.hidden = false;
      const updateButton = () => {
        button.dataset.paused = String(video.paused);
        button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      };
      const sync = () => {
        if (!visible || document.hidden || !wanted) { video.pause(); updateButton(); return; }
        if (video.paused && !pending) {
          pending = true;
          video.play().catch(() => {}).finally(() => { pending = false; updateButton(); });
        }
      };
      button.addEventListener('click', () => { wanted = video.paused; sync(); }, options);
      video.addEventListener('play', () => {
        if (!visible || document.hidden || !wanted) video.pause();
        updateButton();
      }, options);
      video.addEventListener('pause', updateButton, options);
      video.addEventListener('error', () => { button.hidden = true; }, options);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: 0.15});
      observer.observe(video);
      document.addEventListener('visibilitychange', sync, options);
      reduced.addEventListener('change', () => { wanted = !reduced.matches; sync(); }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(video)) { observer.disconnect(); video.pause(); lifecycle.abort(); }
      }, options);
      updateButton();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
